import '@/styles/components/ui/BaseTitle.scss';
import { Box } from '@mui/material';

interface BaseTitleProps {
    icon?: React.ReactNode;
    title: string;
}

function BaseTitle({ icon, title }: BaseTitleProps) {
    return (
        <Box className="base-title">
            <span className="title-icon">{icon}</span>
            <h1>{title}</h1>
        </Box>
    );
}

export default BaseTitle;
